import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const POPS = [
  "Kubu Raya", "Landak", "Bengkayang", "Sanggau", "Sekadau",
  "Melawi", "Sintang", "Putussibau", "Ketapang", "Kayong Utara",
];

const latency = (name, round) => {
  let h = round * 17;
  for (const c of name) h = (h * 31 + c.charCodeAt(0)) % 997;
  return 5 + (h % 21);
};

export default function PopStatus() {
  const [idx, setIdx] = useState(0);
  const [round, setRound] = useState(0);
  const [phase, setPhase] = useState("test");

  useEffect(() => {
    const t =
      phase === "test"
        ? setTimeout(() => setPhase("ok"), 950)
        : setTimeout(() => {
            setPhase("test");
            setIdx((v) => {
              const n = (v + 1) % POPS.length;
              if (n === 0) setRound((r) => r + 1);
              return n;
            });
          }, 1800);
    return () => clearTimeout(t);
  }, [phase]);

  return (
    <div
      data-testid="network-status-pill"
      className="hidden w-[196px] items-center justify-center gap-2 whitespace-nowrap rounded-full border border-emerald-400/30 bg-emerald-400/10 px-3 py-1.5 md:flex"
    >
      <span className="relative flex h-2 w-2 shrink-0">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60"></span>
        <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400"></span>
      </span>
      <AnimatePresence mode="wait">
        {phase === "test" ? (
          <motion.span
            key={`test-${idx}`}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.22 }}
            className="font-mono text-xs text-emerald-200/60"
          >
            Tes POP {POPS[idx]}...
          </motion.span>
        ) : (
          <motion.span
            key={`ok-${idx}`}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.22 }}
            className="font-mono text-xs font-bold text-emerald-300"
          >
            POP {POPS[idx]} • {latency(POPS[idx], idx + round)}ms &#10003;
          </motion.span>
        )}
      </AnimatePresence>
    </div>
  );
}
